const ALPHABET = Array.from(
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzАБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдеёжзийклмнопрстуфхцчшщъыьэюя0123456789 .,!?-()'
);

type EnigmaSettings = {
  enigmaCode: string;
  enigmaEnabled: boolean;
}

class EnigmaEncryption {
  public encrypt(text: string, key: string): string {
    return '🔒Enigma\n' + this.transform(text, key);
  }

  public decrypt(text: string, key: string): string {
    if (!this.isEncrypted(text)) return text;
    const raw = text.replace(/^🔒Enigma\n/, '');
    return '🔐Enigma\n' + this.transform(raw, key);
  }

  public isEncrypted(text: string): boolean {
    return text.startsWith('🔒Enigma\n');
  }

  private transform(text: string, key: string): string {
    const seed = this.getSeedFromKey(key);
    const rotor1 = this.createRotor(seed);
    const rotor2 = this.createRotor(seed + 1);
    const rotor3 = this.createRotor(seed + 2);
    const rotor4 = this.createRotor(seed + 3);
    const rotor5 = this.createRotor(seed + 4);
    const reflector = this.createReflector(seed + 99);

    let r1Pos = 0, r2Pos = 0, r3Pos = 0, r4Pos = 0, r5Pos = 0;
    let result = '';

    const chars = Array.from(text);

    for (const char of chars) {
      if (!ALPHABET.includes(char)) {
        result += char;
        continue;
      }

      r1Pos = (r1Pos + 1) % ALPHABET.length;
      if (r1Pos === 0) r2Pos = (r2Pos + 1) % ALPHABET.length;
      if (r2Pos === 0 && r1Pos === 0) r3Pos = (r3Pos + 1) % ALPHABET.length;
      if (r3Pos === 0 && r2Pos === 0 && r1Pos === 0) r4Pos = (r4Pos + 1) % ALPHABET.length;
      if (r4Pos === 0 && r3Pos === 0 && r2Pos === 0 && r1Pos === 0) r5Pos = (r5Pos + 1) % ALPHABET.length;

      const step1 = this.rotateRotor(rotor1, r1Pos);
      const step2 = this.rotateRotor(rotor2, r2Pos);
      const step3 = this.rotateRotor(rotor3, r3Pos);
      const step4 = this.rotateRotor(rotor4, r4Pos);
      const step5 = this.rotateRotor(rotor5, r5Pos);

      let c = char;

      // Прямой проход через 5 роторов
      c = step1[ALPHABET.indexOf(c)];
      c = step2[ALPHABET.indexOf(c)];
      c = step3[ALPHABET.indexOf(c)];
      c = step4[ALPHABET.indexOf(c)];
      c = step5[ALPHABET.indexOf(c)];

      // Отражатель
      c = reflector[ALPHABET.indexOf(c)];

      // Обратный проход через 5 роторов (в обратном порядке!)
      c = ALPHABET[step5.indexOf(c)];
      c = ALPHABET[step4.indexOf(c)];
      c = ALPHABET[step3.indexOf(c)];
      c = ALPHABET[step2.indexOf(c)];
      c = ALPHABET[step1.indexOf(c)];

      result += c;
    }

    return result;
  }

  private getSeedFromKey(key: string): number {
    return Array.from(key).reduce((sum, c) => sum + c.charCodeAt(0), 0);
  }

  private createRotor(seed: number): string[] {
    const chars = [...ALPHABET];
    for (let i = chars.length - 1; i > 0; i--) {
      const j = (seed + i * 31) % chars.length;
      [chars[i], chars[j]] = [chars[j], chars[i]];
    }
    return chars;
  }

  private createReflector(seed: number): string[] {
    const chars = [...ALPHABET];
    const reflector = new Array(ALPHABET.length);
    const used = new Set<number>();

    for (let i = 0; i < chars.length; i++) {
      if (used.has(i)) continue;

      let j = (seed + i * 31) % chars.length;
      while (j === i || used.has(j)) {
        j = (j + 1) % chars.length; // Простая защита от самосоответствия
      }

      reflector[i] = chars[j];
      reflector[j] = chars[i];
      used.add(i);
      used.add(j);
    }
    return reflector;
  }

  private rotateRotor(rotor: string[], n: number): string[] {
    return rotor.slice(n).concat(rotor.slice(0, n));
  }


  loadEnigmaSettings(chatId: string) : EnigmaSettings {
    let enigmaSettings = sessionStorage.getItem('enigmaSettings_' + chatId);
    let enigmaCode = '';
    let isEnigmaEnabled = false;
    if(enigmaSettings) {
      let parsedEnigmaSettings = JSON.parse(enigmaSettings);
      enigmaCode = (parsedEnigmaSettings.enigmaCode);
      isEnigmaEnabled = (parsedEnigmaSettings.enigmaEnabled);
    }

    return {
      enigmaCode,
      enigmaEnabled: isEnigmaEnabled
    }
  }
}

export default EnigmaEncryption;
